export default __webpack_public_path__ + "static/media/link.1d648e77.svg";